import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsAction from '../enums/TrailDetailsAction';

type logQRPhoneNumberSubmittedParams = {
  had_app_when_web_to_app_started?: boolean;
  was_plus_when_web_to_app_started?: boolean;
  web_to_app_action?: TrailDetailsAction;
};

/**
 * User submits their phone number on web to enable an action in the app.
 * @param params - Attributes to log with the amplitude event
 * @param params.had_app_when_web_to_app_started - TRUE if the user had the app successfully downloaded when they started the web to app transfer.
 * @param params.was_plus_when_web_to_app_started - TRUE if the user was a plus user when they started the web to app transfer.
 * @param params.web_to_app_action - The action that the user wants to transfer to their app.
 */
const logQRPhoneNumberSubmitted = (
  { had_app_when_web_to_app_started, was_plus_when_web_to_app_started, web_to_app_action }: logQRPhoneNumberSubmittedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'qr phone number submitted',
    {
      'had app when web to app started': had_app_when_web_to_app_started,
      'was plus when web to app started': was_plus_when_web_to_app_started,
      'web to app action': web_to_app_action
    },
    callback
  );
};

export default logQRPhoneNumberSubmitted;
